import { render, staticRenderFns } from "./CreditCardItem.vue?vue&type=template&id=22cdd109&scoped=true&"
import script from "./CreditCardItem.vue?vue&type=script&lang=ts&"
export * from "./CreditCardItem.vue?vue&type=script&lang=ts&"
import style0 from "./CreditCardItem.vue?vue&type=style&index=0&id=22cdd109&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cdd109",
  null
  
)

export default component.exports